import React from 'react';
import { motion } from 'framer-motion';
import { BadgeCheckIcon, TrendingUpIcon, BrainIcon } from 'lucide-react';
export const AboutHost = () => {
  return <section className="py-12 px-4 relative" data-id="element-22">
      {/* Efecto de luz */}
      <div className="absolute -right-40 top-1/2 -translate-y-1/2 w-80 h-80 bg-pink-500/20 blur-[120px] rounded-full" data-id="element-23"></div>
      <div className="container mx-auto max-w-6xl relative z-10" data-id="element-24">
        <div className="flex flex-col md:flex-row items-center gap-12" data-id="element-25">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6
        }} viewport={{
          once: true
        }} className="md:w-5/12" data-id="element-26">
            <div className="relative" data-id="element-27">
              <div className="w-full h-full absolute -left-3 -top-3 border-2 border-purple-500 rounded-2xl" data-id="element-28"></div>
              <div className="w-72 h-72 mx-auto overflow-hidden rounded-2xl border-2 border-gray-700 relative bg-gradient-to-tr from-blue-900/30 to-purple-900/30" data-id="element-29">
                {/* Imagen de perfil de Sharon Tirado */}
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/t4FFHkFeU2s12uXAxDdwc6/DSC_4499_2.jpg" alt="Sharon Tirado" className="w-full h-full object-cover" data-id="element-30" />
                {/* Efecto de brillo */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" data-id="element-31"></div>
                {/* Insignia */}
                <div className="absolute bottom-4 left-4 bg-gradient-to-r from-blue-600 to-purple-600 px-3 py-1 rounded-full text-sm font-medium" data-id="element-32">
                  <span className="flex items-center gap-1" data-id="element-33">
                    <BadgeCheckIcon size={14} data-id="element-34" />
                    <span data-id="element-35">Experta en Marketing</span>
                  </span>
                </div>
              </div>
            </div>
          </motion.div>
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6
        }} viewport={{
          once: true
        }} className="md:w-7/12" data-id="element-36">
            <h2 className="text-3xl font-bold mb-6" data-id="element-37">
              Conoce a tu mentora:{' '}
              <span className="bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-purple-400" data-id="element-38">
                Sharon Tirado
              </span>
            </h2>
            <p className="text-gray-300 mb-6" data-id="element-39">
              Sharon es una reconocida experta en marketing digital y ventas
              online potenciadas por Inteligencia Artificial. Con más de 6 años
              de experiencia ayudando a emprendedores a crear y monetizar
              productos digitales, ha desarrollado un método único que combina
              estrategias de venta probadas con las últimas tecnologías de IA.
            </p>
            <div className="space-y-4" data-id="element-40">
              <div className="flex items-start gap-3" data-id="element-41">
                <div className="p-2 rounded-lg bg-blue-900/30 text-blue-400 mt-1" data-id="element-42">
                  <TrendingUpIcon size={20} data-id="element-43" />
                </div>
                <div data-id="element-44">
                  <h4 className="font-bold text-lg" data-id="element-45">
                    Experta en ventas digitales
                  </h4>
                  <p className="text-gray-400" data-id="element-46">
                    Ha ayudado a más de 1,000 estudiantes a crear y monetizar
                    sus productos digitales.
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-3" data-id="element-47">
                <div className="p-2 rounded-lg bg-purple-900/30 text-purple-400 mt-1" data-id="element-48">
                  <BrainIcon size={20} data-id="element-49" />
                </div>
                <div data-id="element-50">
                  <h4 className="font-bold text-lg" data-id="element-51">
                    Pionera en IA para negocios
                  </h4>
                  <p className="text-gray-400" data-id="element-52">
                    Especializada en aplicar herramientas de IA para crear
                    productos digitales de alta calidad en tiempo récord.
                  </p>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
};